const BackToTop = {
  btn: null,
  footerObserver: null,
  threshold: 300, // px de scroll para o botão aparecer

  init() {
    this.btn = document.getElementById('back-to-top');
    if (!this.btn) return;

    this._onScroll();
    window.addEventListener('scroll', () => this._onScroll(), { passive: true });
    this.btn.addEventListener('click', () => this._scrollToTop());

    const footer = document.getElementById('footer');
    if (!footer || !('IntersectionObserver' in window)) return;

    this.footerObserver = new IntersectionObserver(([entry]) => {
      this.btn.classList.toggle('is-over-footer', entry.isIntersecting);
    });
    this.footerObserver.observe(footer);
  },

  _onScroll() {
    if (window.scrollY >= this.threshold) {
      this.btn.classList.add('is-visible');
    } else {
      this.btn.classList.remove('is-visible');
    }
  },

  _scrollToTop() {
    const start = window.scrollY;
    const duration = 400;
    let startTime = null;

    const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start * (1 - easeInOutQuad(progress)));
      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  },
};

export default BackToTop;
